import { Paper } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import FeedbackReview from "../../features/dashboard/feedbackReview";
import MainContainer from "../../layout/MainContainer";
// import {
//   DashboardResponse,
//   useLazyDashboardDataQuery,
// } from "../../service/dashboard";
import LineChart from "components/LineChart";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#204e33" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Dashboard = () => {
  const navigate = useNavigate();
  // const [dashboard] = useLazyDashboardDataQuery();
  // const [dashboardData, setDashboardData] = useState<DashboardResponse>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // const getDashboardData = async () => {
  //   setIsLoading(true);

  //   try {
  //     const res = await dashboard().unwrap();
  //     if (res?.statusCode === 200) {
  //       setDashboardData(res?.data || {});
  //     } else {
  //     }
  //   } catch (error: any) {
  //     showError(error?.data?.message || '');
  //     // setDashboardData({})
  //   }
  //   setIsLoading(false);
  //   // ref?.current?.complete();
  // };

  // const { isAdd, isDelete } = usePermission({
  //   label: 'Dashboard',
  //   page_permission: 'isView',
  // });
  const graphOrderData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Users",
        data: [
          "8",
          "4",
          "25",
          "6",
          "34",
          "35",
          "34",
          "66",
          "24",
          "30",
          "87",
          "6",
        ],
        borderColor: "#006039",
        backgroundColor: "rgba(0, 96, 57, 0.2)", // This fills the area
        fill: true, // Explicitly tell it to fill
        color: "#FFFFF",
      },
    ],
  };
  const graphDealerData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Bookings",
        data: [
          "2",
          "10",
          "15",
          "17",
          "53",
          "26",
          "29",
          "18",
          "46",
          "60",
          "73",
          "95",
        ],
        borderColor: "#006039",
        backgroundColor: "rgba(0, 96, 57, 0.2)", // This fills the area
        fill: true, // Explicitly tell it to fill
        color: "#FFFFF",
      },
    ],
  };
  const graphStoreData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Cars",
        data: [
          "10",
          "20",
          "25",
          "15",
          "50",
          "10",
          "20",
          "25",
          "15",
          "50",
          "20",
          "25",
        ],
        borderColor: "#006039",
        backgroundColor: "rgba(0, 96, 57, 0.2)", // This fills the area
        fill: true, // Explicitly tell it to fill
        color: "#FFFFF",
      },
    ],
  };
  const graphPostsData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Revenue",
        data: [
          "10",
          "20",
          "25",
          "15",
          "50",
          "10",
          "20",
          "25",
          "15",
          "50",
          "20",
          "25",
        ],
        borderColor: "#006039",
        backgroundColor: "rgba(0, 96, 57, 0.2)", // This fills the area
        fill: true, // Explicitly tell it to fill
        color: "#FFFFF",
      },
    ],
  };

  // useEffect(() => {
  //   getDashboardData();
  // }, []);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Dashboard</h1>
      </div>
      <div className="stats_boxes gap_m">
        <div
          className="cards"
          // onClick={() => navigate("/dashboard/uninstalled-users")}
        >
          <figure>
            <img
              src="/static/images/add-friend.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>50</h2>
          <p>Total users</p>
        </div>
        <div
          className="cards"
          // onClick={() => navigate("/dashboard/registered-users")}
        >
          <figure>
            <img
              src="/static/images/add-friend.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>7</h2>
          <p>New User Today</p>
        </div>

        <div
          className="cards"
          // onClick={() => navigate("/dashboard/downloaded-users")}
        >
          <figure>
            <img
              src="/static/images/booking.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>120</h2>
          <p>Total Bookings</p>
        </div>

        <div
          className="cards"
          // onClick={() => navigate("/dashboard/downloaded-users")}
        >
          <figure>
            <img
              src="/static/images/car2.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>60</h2>
          <p>Total cars listed</p>
        </div>

        <div
          className="cards"
          // onClick={() => navigate("/dashboard/downloaded-users")}
        >
          <figure>
            <img
              src="/static/images/booking.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>40</h2>
          <p>Total car bookings</p>
        </div>

        <div
          className="cards"
          // onClick={() => navigate("/dashboard/downloaded-users")}
        >
          <figure>
            <img
              src="/static/images/profit.png"
              alt=""
              style={{ height: "30px", width: "30px" }}
            />
          </figure>
          <h2>AED 50,000</h2>
          <p>Total revenue</p>
        </div>
      </div>
      <div className="grid_sc gap_m ">
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Total Users</h2>
          <LineChart data={graphOrderData} />
        </Item>
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Total Bookings</h2>
          <LineChart data={graphDealerData} />
        </Item>
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Total Cars Listed</h2>
          <LineChart data={graphStoreData} />
        </Item>
        <Item className="cards" style={{ borderRadius: "15px" }}>
          <h2 className="mn_hdng">Revenue</h2>
          <LineChart data={graphPostsData} />
        </Item>
      </div>
    </MainContainer>
  );
};

export default Dashboard;
